<app-card [state]="product.state" header="{{product.specs.title}}">
  <app-badge ngProjectAs="[badge]" [icon]="getProductIcon()"/>
  <div>
    {{ product.specs.description }}
  </div>
  @if (product.state !== ProductState.PENDING) {
    <app-divider/>
  }
  @if (product.state !== ProductState.PENDING && product.discounted_price) {
    <app-product-price-display
      [product]="product"/>
  }
  @if (product.state !== ProductState.PENDING) {
    <div class="price-box">
      <span class="price">
        <app-currency
          [value]="product.price"
          [monthly]="product.product_sub_type !== ProductSubType.TV_SMARTCARD"
          [emphasis]="true"
          size="large"
          />
      </span>
    </div>
  }

  @if (!product.state || product.state === ProductState.INACTIVE) {
    <app-button ngProjectAs="[button]" type="primary"
      (click)="toBeOrdered.emit(product)"
      onKeyUp="">
      Bestellen
    </app-button>
  }
</app-card>
